import { useEffect, useState } from 'react';

import { DiscussionStatusTag } from '~/lib/discussions/types';
import { DiscussionStatusItem } from './DiscussionStatusItem';

interface DiscussionState {
  isApproved: boolean | null | undefined;
  isResolved: boolean | undefined;
}

export default function DiscussionStatus({
  isApproved,
  isResolved,
}: DiscussionState) {
  const [status, setStatus] = useState<DiscussionStatusTag>({
    text: '',
    bgColor: '',
  });

  useEffect(() => {
    if (typeof isApproved === 'undefined' || isApproved === null) {
      setStatus({ text: 'Pending Moderation', bgColor: 'bg-sunset' });
      return;
    }

    if (!isApproved) {
      setStatus({ text: 'Denied', bgColor: 'bg-ready-red' });
      return;
    }

    setStatus({ text: '', bgColor: '' });
  }, [isApproved]);

  if (isResolved && !status.text) {
    return <></>;
  }

  return (
    <div className="flex gap-2">
      {status.text && (
        <DiscussionStatusItem text={status.text} bgColor={status.bgColor} />
      )}
      {!isResolved && (
        <DiscussionStatusItem text="Unresolved" bgColor="bg-entrepurple" />
      )}
    </div>
  );
}
